export const ME_PREFERENCES = 'me-preferences'
export const PATIENT_HOME = {
  RESERVATION_CARD: 'patient-home-reservation-card',
  RESERVATION_SPECIALTY_SELECTOR: 'patient-home-reservation-specialty-selector',
}